module.exports = __webpack_public_path__ + "img/y.47ac6610.jpg";